export const API_CONSTANTS = {
  LOGIN: "/user/auth/login",
  ACTIVE_LANG: "/supported-language/active",
  PERMISSION: "/role/get/config",
  SYSTEM_CONFIG: "/system-manager/config/1",
};
